<template>
    <div class="bg ratio-169-content">

        <svg xmlns="http://www.w3.org/2000/svg" width="54" height="39" viewBox="0 0 54 39" fill="none" v-if="!isMobile" class="youtube-icon">
            <path d="M52.8283 6.80087C52.2083 4.476 50.3815 2.64501 48.0621 2.02364C43.858 0.894531 27 0.894531 27 0.894531C27 0.894531 10.1421 0.894531 5.93787 2.02364C3.61845 2.64511 1.7917 4.476 1.17169 6.80087C0.0451965 11.0148 0.0451965 19.8068 0.0451965 19.8068C0.0451965 19.8068 0.0451965 28.5989 1.17169 32.8128C1.7917 35.1377 3.61845 36.8924 5.93787 37.5138C10.1421 38.6429 27 38.6429 27 38.6429C27 38.6429 43.8579 38.6429 48.0621 37.5138C50.3815 36.8924 52.2083 35.1377 52.8283 32.8128C53.9548 28.5989 53.9548 19.8068 53.9548 19.8068C53.9548 19.8068 53.9548 11.0148 52.8283 6.80087ZM21.4865 27.7893V11.8243L35.5764 19.807L21.4865 27.7893Z" fill="white"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="77" height="54" viewBox="0 0 77 54" fill="none" v-else class="youtube-icon">
            <path d="M75.391 8.44917C74.5054 5.12339 71.8963 2.50411 68.5834 1.61522C62.5786 0 38.5 0 38.5 0C38.5 0 14.4215 0 8.4166 1.61522C5.10373 2.50425 2.49455 5.12339 1.60899 8.44917C0 14.4773 0 27.0546 0 27.0546C0 27.0546 0 39.6318 1.60899 45.66C2.49455 48.9857 5.10373 51.4959 8.4166 52.3848C14.4215 54 38.5 54 38.5 54C38.5 54 62.5784 54 68.5834 52.3848C71.8963 51.4959 74.5054 48.9857 75.391 45.66C77 39.6318 77 27.0546 77 27.0546C77 27.0546 77 14.4773 75.391 8.44917ZM30.6249 38.4737V15.6354L50.7499 27.0548L30.6249 38.4737Z" fill="white"/>
        </svg>

        <div class="hightlights-title">
            {{ $t('HIGHLIGHTS') }}
        </div>

        <div class="hightlights-content">
            www.youtube.com
        </div>

        <a :href="videoUrl" target="__blank">
            <button class="hightlights-button">
                {{ $t('WATCH_ON_YOUTUBE') }}
            </button>
        </a>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        videoUrl: String
    },
    computed: {
        ...mapGetters([
            'isMobile'
        ])
    }
}
</script>

<style scoped>
.bg {
    border-radius: 8px;
    background: linear-gradient(108deg, #F00 0%, #2279D0 100%);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
}    
.hightlights-title {
    margin-top: 11.2px;
    color: var(--color-button-active);
    font-size: 14px;
    font-family: var(--weight-600);
}
.hightlights-content {
    color: var(--color-button-active);
    font-size: 11px;
    font-family: var(--weight-600);

}
.hightlights-button {
    background-color: #F00;
    color: var(--color-button-active);
    border-radius: 8px;
    font-size: 13px;
    margin-top: 8px;
    padding: 8px;
    box-sizing: border-box;
    outline: none;
    border: 0;
    font-family: var(--weight-600);
    cursor: pointer;
}
.youtube-icon {
    flex-shrink: 0;
}
@media(max-width: 768px) {  /* for test */
.bg {
    border-radius: 2px;
    background: linear-gradient(108deg, #F00 0%, #2279D0 100%);
    width: 100%;
    position: absolute;
    padding: 0;
    top: 0;
    left: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}    
.hightlights-title {
    margin-top: 16px;
}
.hightlights-button {
    margin-top: 24px;
}
}
</style>